<div class="table-mini-wrapper clickable" [ngClass]="{'freeplay-table-mini-wrapper': !isClub()}">
    @if (game().type === 'RNG') {
        @if(isClub()) {
            @if (ringTable().amIPlaying) {
                <ng-container [ngTemplateOutlet]="amIPlaying"></ng-container>
            }
            
            <div
                class="table"
                [ngClass]="{'table-union': isUnion(), deleted: ringTable().gameServer.state === 'UnAllocated' && gameInitialized, 'main-stage-table': mainStageGame()}"
                routerDirection="forward"
                (click)="tableRedirect(ringTable().tableID)"
            >
                @if (!mainStageGame()) {
                    @if (gameInitialized) {
                        <table-countdown
                            [type]="game().type"
                            [dateFrom]="ringTable().createdDate"
                            class="counter-display counter-display-ring"
                        ></table-countdown>
                    }
                    
                    <ng-container [ngTemplateOutlet]="tableTopAndLogo" [ngTemplateOutletContext]="{table: ringTable()}"></ng-container>
                    
                    <div class="table__middle">
                        <ng-container [ngTemplateOutlet]="tableData" [ngTemplateOutletContext]="{requireKyc: false, isMtt: false, restricted: ringTable().restricted}"></ng-container>
                        
                        <div class="table_name">
                            <div class="title-wrapper">
                                <div class="table-name-text">{{ ringTable().tableName }}</div>
                            </div>
                        </div>
                        
                        @if (waitingListShowCheck(ringTable())) {
                            <waiting-list
                                [myID]="myId"
                                [clubID]="getClubId()"
                                [tableID]="ringTable().tableID"
                                [waitinglist]="ringTable().waitinglist"
                                [gameServer]="ringTable().gameServer"
                            ></waiting-list>
                        }
                        
                        <div class='buy-in-range'>
                            <span>Buy-in Range: </span>
                            <span>{{ringTable().minBuyIn}}-{{ringTable().maxBuyIn}}</span>
                        </div>
                    </div>
                    <div class="table-type-text">RING</div>
                }
            </div>
        } @else {
            <div class="table" [ngClass]="{'has-players-gold': freeplayRingTable().notEmptySeats > 0}" (click)="tableRedirect(freeplayRingTable().tableID)">
                <ng-container [ngTemplateOutlet]="tableTopAndLogo" [ngTemplateOutletContext]="{table: freeplayRingTable()}"></ng-container>
                <div class="table__middle">
                    <div class="table_name">
                        <div class="title-wrapper">
                            <div class="table-name-text">{{ freeplayRingTable().tableName }}</div>
                        </div>
                    </div>
                    @if (freeplayRingTable().bombPotConfig !== null) {
                        <div class="bomb-pot-badge">
                            <div class="bomb-pot-label">BOMB POT</div>
                            <div class="bomb-pot-rule-line">Every {{freeplayRingTable().bombPotConfig!.triggerEveryNHands}} hands</div>
                            <div class="bomb-pot-rule-line">{{freeplayRingTable().bombPotConfig!.contributionInBigBlinds}} BB</div>
                        </div>
                    }
                    <div class='buy-in-range'>
                        <span>Buy-in Range: </span>
                        <span>{{ freeplayRingTable().minBuyIn }}-{{ freeplayRingTable().maxBuyIn }}</span>
                    </div>
                </div>
                <div class="table-type-text">RING</div>
            </div>
        }
    }

    @if (game().type === 'SNG') {
        @if (sngTable().amIPlaying) {
            <ng-container [ngTemplateOutlet]="amIPlaying"></ng-container>
        }

        <div
            class="table table-sng"
            [ngClass]="{'table-union': isUnion(), deleted: sngTable().isDeleted, 'main-stage-table': mainStageGame()}"
            routerDirection="forward"
            (click)="navigateToTable(sngTable().tableID,sngTable().type);"
        >
            @if (!mainStageGame()) {
                <ng-container [ngTemplateOutlet]="tableTopAndLogo" [ngTemplateOutletContext]="{table: sngTable()}"></ng-container>

                <div class="table__middle">
                    <ng-container [ngTemplateOutlet]="tableData" [ngTemplateOutletContext]="{requireKyc: false, isMtt: false, restricted: sngTable().restricted}"></ng-container>
                    
                    <div class="table_name">
                        <div class="title-wrapper">
                            <div class="table-name-text">{{ sngTable().tableName }}</div>
                        </div>
                    </div>
                </div>

                <div class="table-type-text">SNG</div>
            }
        </div>
    }

    @if (game().type === 'MTT') {
        @if (mttTable().amIPlaying) {
            <ng-container [ngTemplateOutlet]="amIPlaying"></ng-container>
        }

        <div
            class="table table-mtt"
            [ngClass]="{'table-union': isUnion(), deleted: mttTable().isDeleted, 'main-stage-table': mainStageGame()}"
            routerDirection="forward"
            (click)="navigateToTable(mttTable().tableID, game().type);"
        >
            @if (!mainStageGame()) {
                <ng-container [ngTemplateOutlet]="tableTopAndLogo" [ngTemplateOutletContext]="{table: mttTable()}"></ng-container>

                <div class="table__middle">
                    
                    <ng-container [ngTemplateOutlet]="tableData" [ngTemplateOutletContext]="{requireKyc: mttTable().requireKyc, isMtt: true, restricted: mttTable().restricted}"></ng-container>

                    <div class="table_name">
                        <div class="title-wrapper">
                            <div class="table-name-text">{{ mttTable().tableName }}</div>
                        </div>
                    </div>

                    @if (mttTable().isBeforeStart && gameInitialized) {
                        <table-countdown
                            [type]="game().type"
                            [dateFrom]="mttTable().startingDate"
                            class="counter-display"
                        ></table-countdown>
                    }

                    <div class="start-date">
                        <span>{{ (mttTable().startingDate * 1000) | sopoDate: sopoDateOptions}}</span>
                    </div>
                </div>

                <div class="table-type-text">MTT</div>
            }
        </div>
    }
</div>


<ng-template #amIPlaying>
    <div class="current-playing">
        <div class="play__container">
            <ion-icon name="play-sharp"></ion-icon>
        </div>
    </div>
</ng-template>


<ng-template #tableTopAndLogo let-table="table">
    <div class="table__top">
        <div class="table__game-mode"><span>{{table.gameType}}</span></div>
        <div class="table__game-info">
            @if (table.buyIn) {
                <span>{{table.buyIn}} {{getGameModeLimitType(table.limitType)}}</span>
            } @else {
                <span>{{table.blinds}} {{getGameModeLimitType(table.limitType)}}</span>
            }
        </div>
        <div
            class="table__game-info"
            (click)="manageJoinRequests(table.tableID, table.restrictedRequests, $event)"
        >
            @if(table.type == 'RNG') {
                <span class="seats">{{ table.notEmptySeats }} / {{ table.seats }}</span>
            } @else {
                <span class="seats">{{ table.seats }} max</span>
            }
            @if (isClub() && (table.restrictedRequests > 0) && isAdmin) {
                <app-sopo-badge class="number-of-request" [count]="table.restrictedRequests"></app-sopo-badge>
            }
        </div>
    </div>
</ng-template>

<ng-template #tableData let-requireKyc="requireKyc" let-isMtt="isMtt" let-restricted="restricted">
    <div class="table-data">
        @if (requireKyc) {
            <div class="kyc">
                <img src="/assets/icon/yellow-check.webp" />
                KYC
            </div>
        }

        @if (isMtt) {
            <div class="timer-clock">
                <span class="mtt-clock"><img src="/assets/icon/clock-mtt.svg" /></span>
                <span class="mtt-clock-number">{{mttTable().blindsTime}}</span>
            </div>
        }

        @if (restricted) {
            <div class="lock-icon">
                <img src="/assets/icon/yellow-lock.webp" />
            </div>
        }
    </div>
</ng-template>
